module.exports = __webpack_public_path__ + "img/reason-report.0578652f.png";